import AppBar from "@mui/material/AppBar";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import React from "react";
import { api, ui } from "../../../../../../../interfaces/interfaces";
import BookingSwitches from "./BookingSwitch";
import TabPanel from "../../../../../../Shared/StepThreeTabPanel"
import useDebugInformation from "../../../../../../../hooks/useDebugInformation";
import PaymentBillingDetails from "./Billing";
import { Box, Typography } from "@mui/material";
import { useAppSelector } from "@store/hooks";
import SwipeableViews from "@arzymski/react-swipeable-views";

const name = "BookingTab"

const a11yProps = (index: number) => {
  return {
    id: `action-tab-${index}`,
    "aria-controls": `action-tabpanel-${index}`,
  };
}

const handleChange = (event: React.SyntheticEvent<Element, Event>, value: any) => {
  ui.BookingPaymentActiveTab = value
};

const handleChangeIndex = (index: any) => {
  ui.BookingPaymentActiveTab = index
};

type Props = {
  parent: string
}

const BookingTab: React.FC<Props> = ({ parent }) => {
  const bookingPaymentActiveTab = useAppSelector(({ ui }) => ui.BookingPaymentActiveTab)
  const bookingPaymentIsBooked = useAppSelector(({ ui }) => ui.BookingPaymentIsBooked)
  const bookingPaymentTabsList = useAppSelector(({ ui }) => ui.BookingPaymentTabsList)
  const propertyIsBusiness = useAppSelector(({ ui }) => ui.PropertyAddressIsBusiness)
  const callTypeId = useAppSelector(({ state }) => state.CallTypeId)
  const isAGoBack = useAppSelector(({ state }) => state.IsAGoBack)
  const isAQuote = useAppSelector(({ state }) => state.IsAQuote)

  const debugName = `${parent}▷[${name}]`

  React.useEffect(() => {
    const getPaymentMethods = async () => {
      const body = {
        callTypeId : callTypeId || 0,
        isCommercial: propertyIsBusiness
      }
      await api.fetchPaymentMethods(body)
    }
    getPaymentMethods()
  }, [callTypeId, propertyIsBusiness])

  useDebugInformation(debugName, { bookingPaymentActiveTab, bookingPaymentIsBooked, bookingPaymentTabsList })
  return (
    <Box sx={(theme) => ({
      backgroundColor: theme.palette.background.paper,
      width: "100%",
      position: "relative",
      minHeight: 160,
      '& .react-swipeable-view-container > div': { overflow: "hidden !important" }
    })}>
      {!isAGoBack?.state && !isAQuote && <BookingSwitches />}
      {(isAGoBack?.state || isAQuote) && <Typography variant="h3" textAlign="center" sx={{ mt: 5 }}>Ready to Save booking!</Typography>}
      {bookingPaymentIsBooked && (
        <>
          <AppBar position="static" color="default">
            <Tabs
              sx={{
                minHeight: "32px",
              }}
              value={bookingPaymentActiveTab}
              onChange={handleChange}
              indicatorColor="primary"
              textColor="primary"
              variant="fullWidth"
              aria-label="action tabs example"
            >

              <Tab sx={{ minHeight: "32px" }} label={`Booking Details`} {...a11yProps(0)} />
            </Tabs>
          </AppBar>
          <SwipeableViews
            axis="x"
            index={bookingPaymentActiveTab}
            onChangeIndex={handleChangeIndex}
          >
            <TabPanel parent={debugName} value={bookingPaymentActiveTab} index={0} >
              <PaymentBillingDetails parent={debugName} />
            </TabPanel>
          </SwipeableViews>
        </>)}
    </Box >)
}

export default BookingTab